import { render, staticRenderFns } from "./dishLibrary.vue?vue&type=template&id=52e696ac&scoped=true"
import script from "./dishLibrary.vue?vue&type=script&lang=js"
export * from "./dishLibrary.vue?vue&type=script&lang=js"
import style0 from "./dishLibrary.vue?vue&type=style&index=0&id=52e696ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e696ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e696ac')) {
      api.createRecord('52e696ac', component.options)
    } else {
      api.reload('52e696ac', component.options)
    }
    module.hot.accept("./dishLibrary.vue?vue&type=template&id=52e696ac&scoped=true", function () {
      api.rerender('52e696ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/dishLibrary.vue"
export default component.exports